// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"d8ddeb5e","268":"d8ddeb5e","671":"de9a93f6","677":"5d644014","906":"d8ddeb5e","980":"de9a93f6"}[chunkId] + ".chunk.css";
};